export default "__VITE_ASSET__BRuuJzPf__"